import React, { useState } from 'react';
import TripDayHotelSuggestedModal from '../TripDayHotelSuggestedModal';
import TripDayItemSelector from '../TripDayItemSelector';
import TripDayItemSelectorDisabled from '../TripDayItemSelectorDisabled';
import TripHotelCard from '../TripHotelCard';

export default function TripDayHotelEmptyState({
  dayIndex,
  date,
  program,
  suggestedHotelIds,
  addHotel,
  readOnly = false,
  locale,
  tripHotelCardProps,
  t,
}: {
  dayIndex: number;
  date: any;
  program: any;
  suggestedHotelIds: any[];
  addHotel: (hotel: any) => void;
  // DMC only: a partner's day (per useIsDayEditable) offers no hotel
  // selector at all — TO's days are never readOnly.
  readOnly?: boolean;
  locale?: string;
  tripHotelCardProps?: any;
  t: (key: string, options?: Record<string, any>) => string;
}) {
  const [showModal, setShowModal] = useState(false);

  if (readOnly) {
    return (
      <div className="h-full">
        <TripDayItemSelectorDisabled>
          {t('compose.managedByPartner')}
        </TripDayItemSelectorDisabled>
      </div>
    );
  }

  return (
    <div className="h-full">
      <TripDayHotelSuggestedModal
        open={showModal}
        close={() => setShowModal(false)}
        hotelIds={suggestedHotelIds}
        isIncluded={program?.isIncludedAccomodation}
        date={date}
        title={
          program?.isIncludedAccomodation
            ? t('compose.exploreIncludedHotels')
            : t('compose.exploreSuggestedHotels')
        }
        description={
          program?.isIncludedAccomodation
            ? t('compose.exploreIncludedHotelsDescription')
            : undefined
        }
        emptyLabel={
          program?.isIncludedAccomodation
            ? t('compose.noIncludedHotels')
            : t('compose.noSuggestedHotels')
        }
        renderHotelCard={(hotel: any) => (
          <TripHotelCard
            key={hotel.id}
            hotel={hotel}
            addHotel={(value: any) => {
              addHotel(value);
              setShowModal(false);
            }}
            hotelWithPrice={hotel}
            isForTrip={true}
            locale={locale}
            {...tripHotelCardProps}
          />
        )}
      />

      <TripDayItemSelector
        dayIndex={dayIndex}
        type="hotel"
        isIncluded={program?.isIncludedAccomodation}
        onSecondaryClick={() => setShowModal(true)}
        addProgramLabel={t('compose.addProgram')}
        addHotelLabel={t('compose.addHotel')}
        exploreIncludedHotelsLabel={t('compose.exploreIncludedHotels')}
        exploreSuggestedHotelsLabel={t('compose.exploreSuggestedHotels')}
        noProgramLabel={t('compose.dayCard.noProgram')}
        orLabel={t('compose.or')}
        bookOnMyOwnLabel={t('compose.bookOnMyOwn')}
      />
    </div>
  );
}
